import React from "react";
import DataTable from "../../DataTable/index";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const label = { inputProps: { "aria-label": "Switch demo" } };

export default function MyComponent(props) {
  const userRole = useSelector((state) => state.userDetailsReducer?.role);

  const navigate = useNavigate();

  const columns =
    userRole === "admin" || userRole === "super"
      ? [
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Name
              </Typography>
            ),
            selector: (row) => row.name,
            sortable: true,
            cell: (row, index, column, id) => {
              return (
                <p data-tag="allowRowEvents" style={{ marginTop: 15 }}>
                  {row.name}
                </p>
              );
            },
          },
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Chapter
              </Typography>
            ),
            selector: (row) => row.chapter,
            sortable: true,
            cell: (row, index, column, id) => {
              return (
                <p data-tag="allowRowEvents" style={{ marginTop: 15 }}>
                  {row.chapter}
                </p>
              );
            },
          },
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Status
              </Typography>
            ),
            selector: (row) => row?.status,
            cell: (row, i) => {
              return (
                <Switch
                  {...label}
                  disabled={userRole === "player" ? true : false}
                  onChange={(e) => {
                    let switchCourses = row?.status;

                    if (e.target.checked) {
                      switchCourses = "active";
                    } else {
                      switchCourses = "inactive";
                    }

                    props.handleSwitchCourses(row, switchCourses);
                  }}
                  defaultChecked={row?.status == "active" ? true : false}
                />
              );
            },
          },
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Actions
              </Typography>
            ),
            sortable: true,
            cell: (row) => {
              return (
                <>
                  <IconButton
                    style={{ borderRadius: 5 }}
                    disabled={userRole === "player" ? true : false}
                    onClick={() => {
                      props.setselectedrows(row);

                      props.seteditVisible(!props.editVisible);
                      props.setAddCourse({
                        ...props.addCourse,
                        name: row?.name,
                        address: row.address,
                        latitude: row.latitude,
                        longitude: row.longitude,
                        front_9: row.course_combination[0].front_9,
                        back_9: row.course_combination[0].back_9,
                        status: row.status,
                      });
                    }}
                    color="primary"
                    size="medium"
                  >
                    <EditRoundedIcon fontSize="medium" />
                  </IconButton>
                  <IconButton
                    style={{ borderRadius: 5 }}
                    disabled={userRole === "player" ? true : false}
                    onClick={() => {
                      props.onDeletePress();
                      props.setselectedrows(row);
                    }}
                    color="primary"
                    size="medium"
                  >
                    <DeleteRoundedIcon fontSize="medium" />
                  </IconButton>
                </>
              );
            },
          },
        ]
      : [
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Name
              </Typography>
            ),
            selector: (row) => row.name,
            sortable: true,
            cell: (row, index, column, id) => {
              return (
                <p data-tag="allowRowEvents" style={{ marginTop: 15 }}>
                  {row.name}
                </p>
              );
            },
          },
          {
            name: (
              <Typography variant="subtitle2" fontWeight={700}>
                Chapter
              </Typography>
            ),
            selector: (row) => row.chapter,
            sortable: true,
            cell: (row, index, column, id) => {
              return (
                <p data-tag="allowRowEvents" style={{ marginTop: 15 }}>
                  {row.chapter}
                </p>
              );
            },
          },
        ];

  const conditionalRowStyles = {
    headRow: {
      style: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.6)",
        borderRadius: "5px",
      },
    },
    cells: {
      style: {
        "&:hover": {
          cursor: "pointer !important",
        },
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={props?.data}
      selectableRows={false}
      persistTableHead
      pagination={false}
      progressPending={props?.progressPending}
      progressComponent={props?.progressComponent}
      customStyles={conditionalRowStyles}
      direction="vertical"
      striped={true}
      onChangeRowsPerPage={props?.onChangeRowsPerPage}
      clearRow={props?.clearRow}
      onSelectedRowsChange={props?.onSelectedRowsChange}
      onRowClicked={(row, event) => {
        navigate(`/courseDetails/${row._id}`);
      }}
    />
  );
}
